"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalReport = void 0;
const local_id_1 = require("../class/local-id");
const logger_1 = require("../class/logger");
const session_1 = require("../class/session");
const dto_hash_1 = require("../helpers/dto-hash");
const fingerprint_1 = require("../helpers/fingerprint");
const request_1 = require("../helpers/request");
const config_1 = __importDefault(require("../config"));
require("isomorphic-fetch");
class GalReport {
    constructor(args) {
        this.args = args;
        this.idSource = new dto_hash_1.DTOHash();
        this.session = session_1.Session.load();
        this.urlBase = `${this.trimSlashes(args.reportingUri)}/${this.trimSlashes(config_1.default.apiVersionPath)}`;
        this.obscure = args.obscure;
        const opts = {
            baseURL: args.obscure
                ? `${this.urlBase}/r`
                : `${this.urlBase}/report/${this.trimSlashes(args.reportingGroup)}`,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `bearer ${this.encode(args.publisherId)}`,
            },
        };
        this.request = new request_1.FetchRequest(opts);
        this.localId = new local_id_1.LocalId();
        this.fingerprint = new fingerprint_1.Fingerprint({
            endpoint: this.args.fpEndpoint,
            apiKey: config_1.default.fingerprintJS.apiKey,
            scriptUrls: config_1.default.fingerprintJS.scriptUrls,
        });
    }
    send(report, asBeacon = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const event = Object.assign(Object.assign({}, report), { session: this.session.id, elapsed: this.session.elapsedMS, fingerprint: yield this.fingerprint.identify(), localId: this.localId.getId(), prevId: this.idSource.prev });
            if (this.args.environment) {
                event.environment = this.args.environment;
            }
            const type = report.details.type;
            const reportType = this.obscure
                ? this.sendObscured.bind(this)
                : this.sendDirect.bind(this);
            reportType(type, Object.assign(Object.assign({}, event), { id: yield this.idSource.makeId(event) }), asBeacon);
        });
    }
    sendDirect(type, event, asBeacon = false) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.request.post(type, event, asBeacon);
                if (result && !`${result.status}`.startsWith('2')) {
                    logger_1.Logger.warn(`Reporting failed with ${result.status}`);
                }
            }
            catch (err) {
                logger_1.Logger.handle(err);
            }
        });
    }
    sendObscured(type, event, asBeacon = false) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.request.post('', {
                    r: this.encode(JSON.stringify({
                        body: event,
                        group: this.args.reportingGroup,
                        type,
                    })),
                }, asBeacon);
                if (result && !`${result.status}`.startsWith('2')) {
                    logger_1.Logger.error(`Reporting failed with ${result.status}`);
                }
            }
            catch (err) {
                logger_1.Logger.handle(err);
            }
        });
    }
    trimSlashes(str) {
        str = str.trim();
        if (str.endsWith('/')) {
            str = str.substring(0, str.length - 1);
        }
        if (str.startsWith('/')) {
            str = str.substring(1);
        }
        return str;
    }
    encode(str) {
        if (window === null || window === void 0 ? void 0 : window.btoa) {
            return window.btoa(str);
        }
        else {
            return Buffer.from(str).toString('base64');
        }
    }
}
exports.GalReport = GalReport;
